import { layerClass } from "@freightsimple/ui-core/Theme/layers";
import { Spinner } from "@freightsimple/ui-core/Feedback/Spinner";

/**
 * Break glass — the full-viewport blocking loading veil used by multi-step
 * flows that call APIs between dialogs (replica of the legacy Cargo
 * LoadingBackdrop: blur plus a slight dim, with a centred spinner).
 *
 * ui-core has no non-dialog blocking overlay. `Dialog` would bring a card, a
 * close affordance and focus trapping; `Center` can only centre inside normal
 * flow, not `position: fixed` over the whole viewport. The `backdrop-filter`
 * blur+brightness pair has no Tailwind utility either.
 *
 * Render it via `useLoadingOverlay`, not directly.
 */
export function LoadingOverlayBackdrop() {
  return (
    <div
      className={`fixed inset-0 ${layerClass.backdrop} flex h-screen w-screen items-center justify-center [backdrop-filter:blur(6px)_brightness(90%)]`}
    >
      <Spinner size={48} />
    </div>
  );
}
